<template>
						<div class="contactInformation p-4 text-left">
							<template v-if="isCurrentlyEnrolled()">
								<p class="text-xl font-medium py-2">CURRENT TICKET PACKAGE</p>
								<p class="text font-bold pt-2">WinWin Staff Lottery</p>
								<p class="text">{{getCurrentMainTicketPackage()}}</p>
								<p class="text font-bold pt-2">Quarterly Cash 50/50</p>
								<p class="text">{{getCurrent5050TicketPackage()}}</p>

								<p class="text-xs font-medium pt-6 pb=2">DEDUCTIONS ARE MADE EACH PAY PERIOD</p>
								<a href="/settings/update-tickets" class="text-center">
								<button
									class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
								>
									SELECT NEW TICKETS
								</button>
								</a>
							</template>
							<template v-else>
								<div class="text-center">
							<p class="text font-bold pt-2">DON'T MISS ANOTHER DRAW!</p>
							<p class="text-xl font-bold py-2">ENROLL TODAY
								<!-- <br><span class="font-normal">to be eligible for the <br>{{nextDrawDate}} draws.</span> -->
							</p>
							<p class="font-bold py-2">SELECT YOUR 2025 WINWIN STAFF LOTTERY TICKETS AND YOUR NEW QUARTERLY CASH 50|50 TICKETS NOW!</p>
								<a href="/settings/update-tickets" class="text-center">
								<button
									class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
								>
									SELECT NEW TICKETS
								</button>
								</a>
								</div>
							</template>

						</div>
</template>

<script>
	import moment from "moment";

	import { computed } from "vue";
	import { mapGetters, useStore } from "vuex";
	import { WINWINMAINPACKAGES, WINWIN5050PACKAGES, nextDrawDate}  from '@/utils/constants'

    export default {
        name: "CurrentTicketPackages",
        		computed: {
			...mapGetters({
				user: "user",
			}),
			nextDrawDate: function() {
				return nextDrawDate(new Date())
			}
		},

        		computed: {
			...mapGetters({
				user: "user",
			}),
			nextDrawDate: function() {
				return nextDrawDate(new Date())
			}
		},
        methods: {
            			dateTime(value) {
				// format Date object to readible format
				return moment(value).format("MMMM Do, YYYY");
			},
            			isCurrentlyEnrolled: function() {

							return this.user?.apiData?.Profile?.Year2025 && !this.user?.apiData?.Profile?.OptOutMain && !this.user?.apiData?.Profile?.OptOut5050
			},
            			getCurrentMainTicketPackage() {
				var currentMain = this.user?.apiData?.Profile.CurrentMainTicketPackage ?? null;
				var newMain = this.user?.apiData?.Profile.NewMainTicketPackage ?? null;

				var main = newMain || currentMain;
				if (main && !isNaN(main)) {
					var ticketPackage = WINWINMAINPACKAGES.find(x=>x.Cost == main)
					if (ticketPackage) return ticketPackage.Name
				}
			},
			getCurrent5050TicketPackage() {
				var current5050 = this.user?.apiData?.Profile?.Current5050TicketPackage ?? null;
				
				var new5050 = this.user?.apiData?.Profile?.New5050TicketPackage ?? null;

				
				var fiftyFifty = new5050 || current5050

				if (fiftyFifty && !isNaN(fiftyFifty)) {
					var ticketPackage = WINWIN5050PACKAGES.find(x=>x.Cost == fiftyFifty)
					if (ticketPackage) return ticketPackage.Name
				}
			},
        },
    }
</script>

<style lang="scss" scoped>


</style>